const routes = [
    {
        path: "/room/need/cleaning",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "housingreservation_cleaninglist"
        }
    }
]

export default routes;

